// Must match the server enum
export enum OwnershipCalculationType {
  ByContributions = 0,
  ByCommitments = 1
}

export namespace OwnershipCalculationType {
  export function toString(item: OwnershipCalculationType): string {
    switch (item) {
      case OwnershipCalculationType.ByCommitments:
        return 'Commitments';
      case OwnershipCalculationType.ByContributions:
        return 'Contributions';
      default:
        return '';
    }
  }
}

export default OwnershipCalculationType;
